export const SETTINGS_UNKNOWN = 'settings_unknown';
export const SETTINGS_LOADED = 'settings_loaded';

export const settingsType = {
  APP: 'app',
  BUSINESS: 'business',
};
